import {RouteType} from "./constants/RouteType";
import React from "react";

import Dot from "../../assets/v2/dot.png";
import IconFrom from "../../assets/v2/map-pin.png";
import IconTo from "../../assets/v2/goal.png";
import IconGo from "../../assets/v2/go.png";
import {twMerge} from "tailwind-merge";

export default function ValetRouteGraph({
                                            routeType,
                                            halfHeight = false
                                        }) {

    return <div className="w-[32px] mr-3 flex flex-col justify-center items-center">
        <img src={IconFrom} className="mx-auto max-w-xs"/>
        <div style={{
            backgroundImage: `url(${Dot})`,
        }} className={twMerge("bg-repeat-y w-[24px] bg-center flex items-center gap-[10px]", halfHeight ? "h-[calc(100%/2)]" : "h-full" )}>
            <img src={IconGo} className="w-[12px] h-[24px] ml-[-5px]"/>
            {
                routeType === RouteType.GOING_AND_COMING ?
                    <img src={IconGo} className="w-[12px] h-[24px] rotate-180"/> : null
            }
        </div>
        <img src={IconTo} className="mx-auto max-w-xs"/>
    </div>
}